module.exports = __webpack_public_path__ + "static/flags/AR-93100659785a5b1b66e87987e5d05f72.gif";